import PropTypes from 'prop-types';
import StyledContainerPopover from './styled/PopoverContainer.styled';

function PopoverContainer({ children, ...props }) {
  props = {
    ...props,
    absolute: typeof props.absolute === "undefined" ? false : props.absolute
  };

  return (
    <StyledContainerPopover {...props}>
      {children}
    </StyledContainerPopover>
  );
}

PopoverContainer.propTypes = {
  absolute: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default PopoverContainer;
